
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const VendorBreadcrumbs = () => {
  // Get vendor name from Redux
  const selectedVendor = useSelector((state) => state.vendor.selectedVendor);
  const vendorName = selectedVendor ? selectedVendor.name || "Vendor" : "New Vendor";
  return (
    <nav className="flex items-center space-x-2 text-base font-medium my-3">
      <span className="flex items-center">
        <span className="text-neutral-700">Sales</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-1">
          <path d="M16 3.00195L7 12.002L16 21.002" stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
      <span className="flex items-center">
        <Link to="/sales/vendors" className="text-neutral-700 hover:underline">Vendors</Link>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-1">
          <path d="M16 3.00195L7 12.002L16 21.002" stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
      <span className="text-slate-700 capitalize">{vendorName}</span>
    </nav>
  );
};

export default VendorBreadcrumbs;
